var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-row match-height"},[_c('div',{staticClass:"vx-col w-full"},[_c('vx-card',[_c('vs-tabs',{attrs:{"vs-alignment":"fixed","alignment":"fixed"}},[_c('vs-tab',{attrs:{"label":_vm.$t('EditSupplierInfo')}},[_c('edit-individual-supplier')],1),(
            _vm.$tabHasPermission(
              'AssignDocument|UnAssignDocument|GetSupplierDocuments|GetDocumentSettingsByPartyType'
            )
          )?_c('vs-tab',{attrs:{"label":_vm.$t('UploadDocuments')}},[_c('documents-upload',{attrs:{"mode":"individual"}})],1):_vm._e()],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }